import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, Invoice, InvoiceRefund } from 'types';
import { client } from 'utils/api-client';

export default function useRefundInvoice(): UseMutationResult<
  AxiosResponse<Invoice>,
  AxiosError<ErrorMessage>,
  InvoiceRefund
> {
  const queryClient = useQueryClient();

  const refundInvoice = (refund: InvoiceRefund): Promise<AxiosResponse<Invoice>> => {
    return client.post(`invoices/${refund?.invoiceId}/refund/`, refund);
  };

  return useMutation(refundInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries('invoices');
      queryClient.invalidateQueries('total-revenue');
      queryClient.invalidateQueries('package-revenue');
      queryClient.invalidateQueries('package-category-revenue');
    },
  });
}
